/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, CloseIcon, DownloadIcon, MirrorIcon, RotationIcon, ZoomInIcon, ZoomOutIcon } from 'tdesign-icons-react';
import useGlobalIcon from '../../hooks/useGlobalIcon.js';
import '../../hooks/useConfig.js';
import 'react';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-46de7b2e.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';

var useIconMap = function useIconMap() {
  var Icons = useGlobalIcon({
    ChevronDownIcon: ChevronDownIcon,
    ChevronLeftIcon: ChevronLeftIcon,
    ChevronRightIcon: ChevronRightIcon,
    CloseIcon: CloseIcon,
    DownloadIcon: DownloadIcon,
    MirrorIcon: MirrorIcon,
    RotationIcon: RotationIcon,
    ZoomInIcon: ZoomInIcon,
    ZoomOutIcon: ZoomOutIcon
  });
  return {
    rotation: Icons.RotationIcon,
    "zoom-in": Icons.ZoomInIcon,
    mirror: Icons.MirrorIcon,
    "zoom-out": Icons.ZoomOutIcon,
    download: Icons.DownloadIcon,
    "chevron-left": Icons.ChevronLeftIcon,
    "chevron-right": Icons.ChevronRightIcon,
    "chevron-down": Icons.ChevronDownIcon,
    close: Icons.CloseIcon
  };
};

export { useIconMap as default };
//# sourceMappingURL=useIconMap.js.map
